<div class="grid-x grid-margin-x">
  <div class="cell small-12"><label>Hold For:</label></div>
  <div class="cell small-4">
    <input name="holdNumber" type="number" min="0" aria-label="Hold For Number" placeholder="Enter Amount" [(ngModel)]="seConfiguration.holdAmount">
  </div>
  <div class="cell small-8">
    <select name="holdMulitplier" aria-label="Hold For Interval" [(ngModel)]="seConfiguration.holdMulitplier">
      @for (multplr of multipliers; track multplr) {
        <option [value]="multplr.id"> {{ multplr.text }}</option>
      }
    </select>
  </div>
</div>
